import { Navigate } from 'react-router-dom';

import Documents from '../core/documents/pages/documents';
import Home from '../core/home/pages/home';
import Profile from '../core/profile/pages/profile';
import Agreements from '../core/agreements/pages/agreements/agreements';
import AgreementPdfPage from '../core/agreements/pages/agreementPdfPage/agreementPdfPage';
import Login from '../core/login/pages/login';
import BasicScreen from '../core/layout/basicScreeen/basicScreen';
import Impersonate from '../core/impersonate/pages/impersonate';
import DocuSignRedirect from '../core/docuSign/pages/docuSignRedirect/docuSignRedirect';
import NoMatch from '../core/ui/noMatch/noMatch';
import BoardsContainer from '../core/boards/pages/boardsContainer/boardsContainer';
//import Board from '../core/boards/components/board/board';
import ErrorPage from '../core/errorPage/pages/errorPage';
import InvestorBoardsContainer from '../core/boards/pages/investorBoardsContainer/investorBoardsContainer';
import DocuSignResponsive from '../core/docuSign/pages/docuSignResponsive/docuSignResponsive';
import BaseURLConfigStore from '../common/services/config/baseUrlConfigStore';
import BoardProfile from '../core/boards/pages/boardProfile/boardProfile';

const routerConfig = (setShowAgreement?: any, authorized?: any, authenticated?: any, showAgreement?: any) => [
  {
    path: '/',
    element: authenticated ? showAgreement ? <Navigate to='/agreements' /> : authorized ? <BasicScreen /> :
      <Navigate to='/notAuthorized' /> : <Login />,
    children: [
      //{ index: true, element: <Home /> },
      { index: true, element: <Navigate to={BaseURLConfigStore.getStartPageUrl() || '/home'} /> },
      {
        path: '/home',
        element: <Home />,
      },
      {
        path: '/documents',
        element: <Documents />,
      },
      {
        path: '/profile',
        element: <Profile />,
      },
      {
        path: '/impersonate',
        element: <Impersonate />,
      },
      {
        path: '/error',
        element: <ErrorPage />,
      },
      {
        path: '/boards',
        element: <BoardsContainer />,
        children: [
          {
            path: '/boards/:investorId',
            element: <InvestorBoardsContainer />,
            children: [
              {
                path: '/boards/:investorId/:boardId',
                element: <BoardProfile />,
              },
              {
                path: '/boards/:investorId/:boardId/:objectId',
                element: <BoardProfile />,
              },
            ],
          },
        ],
      },
      {
        path: '/docusign/sign',
        element: <DocuSignResponsive />,
      },
      {
        path: '/docusign/redirect/:recipientId',
        element: authenticated ? (
          showAgreement ? (
            <Navigate to='/agreements' />
          ) : authorized ? (
            <DocuSignRedirect />
          ) : (
            <Navigate to='/notAuthorized' />
          )
        ) : (
          <Login />
        ),
      },
      {
        path: '*',
        element: <NoMatch />,
      },
    ],
  },
  {
    path: '/agreements',
    element: authenticated ? <Agreements /> : <Login />,
  },
  {
    path: '/agreements/:assignId',
    element: authenticated ? <AgreementPdfPage setShowAgreement={setShowAgreement} /> : <Login />,
  },
  {
    path: '/agreements/declined',
    element: authenticated ? <Agreements declined /> : <Login />,
  },

  {
    path: '/notAuthorized',
    element: <Login notAuth />,
  },
];

export default routerConfig;
